class VenuesApi {
    constructor(api, opts) {
        this.api = api;
        this.options = {
            ...opts,
        };
    }

    get() {
        return this.api.requestGet(this.api.route('venues.index'), null, { withCredentials: true });
    }
}

export default VenuesApi;
